import { VisiblityElement } from '../visibility/visibility'

/**
 * KeyLookDrawer {@class}
 *
 * Applies 'on-click' event listener to x-modal elements with the data attribute: `data-view-modal="1"`
 * On click will display a pop-out drawer modal with the html elements inside the `div[data-look-ref="${key}"]`
 *
 * The data-look-ref key is also applied to the element secondary element that is storing the HTML that we
 * want to inject into our modal.
 *
 *
 **/
class WishlistDrawer {
  constructor() {
    this.theme = document
    this.visiblity = VisiblityElement
    this._init()
    this._applyHideModal()
  }

  /**
   * Initializes the event listeners once the object has been constructed.
   */
  _init() {
    /** CTA Images that trigger the drawer modal */
    const triggers = this._selectors().triggers
    if (!triggers.length) return

    triggers.forEach((t) => {
      t.addEventListener('click', (e) => {
        /** Pull key from element */
        const key = e.currentTarget.dataset.lookKey
        if (!key) return

        /** Fetch the Key look item reference  */
        const keyLookReference = this.theme.querySelector(`div[data-look-ref="${key}"]`)

        /** If no reference is found or the reference innerHTML is empty, exit */
        if (!keyLookReference) return
        if (!keyLookReference?.innerHTML?.length) return

        /** Add the innerHTML to the form wrapper */
        const formWrapper = this._selectors().form
        formWrapper.innerHTML = keyLookReference.innerHTML

        /** Show the modal and disable scrolling */
        this._viewModal()

        /** Fetch all the inner forms and apply on-submit event listeners */
        const innerFormContext = formWrapper.querySelectorAll('form')
        innerFormContext.forEach((form) => {
          form.addEventListener('submit', this._onSubmit.bind(this))
        })
      })
    })
  }

  /**
   *
   * Handles onSubmit action for each inner form.
   *
   * @param {*} e
   */
  async _onSubmit(e) {
    e.preventDefault()
    const formData = new FormData(e.currentTarget)
    const id = formData.get('variant').toString()

    try {
      if (!id) {
        throw new Error('No variant Id provided.')
      }

      /** Add the item to wishlist local storage */

      // window.Cart.addLineItems({
      //   id,
      //   quantity: 1
      // })
    } catch (err) {
      console.log(err)
    }

    /** Hide the modal */
    this._hideModal()
  }

  /**
   * Updates data-ui attribute on the drawer modal
   * @param {*} state
   */
  _viewModal() {
    this.visiblity.dispatchShow('look')
    this._toggleScroll()
  }

  /**
   * Toggles the document.body scroll.
   * Triggered when the drawer modal is visible or hidden
   */
  _toggleScroll() {
    const body = this.theme.body
    const canScroll = body.classList.contains('overflow-hidden')
    if (canScroll) {
      body.classList.remove('overflow-hidden')
    } else {
      body.classList.add('overflow-hidden')
    }
  }

  /** Applies the click event listener to the backdrop
   * Function called when object constructed.
   */
  _applyHideModal() {
    this._selectors().backdrop.addEventListener('click', this._hideModal.bind(this))
    this._selectors().closeButton.addEventListener('click', this._hideModal.bind(this))
  }

  /** Closes the modal and removes the no-scroll from document.body */
  _hideModal() {
    this.visiblity.dispatchHide('look')
    this._toggleScroll()
  }

  /**
   * PreDefined selectors.
   */
  _selectors() {
    return {
      triggers: this.theme.querySelectorAll('div[data-view-modal="1"]'),
      modal: this.theme.querySelector('[data-modal-view="1"]'),
      form: this.theme.querySelector('div[data-look-form="1"]'),
      drawer: this.theme.querySelector('x-visibility[data-drawer="1"]'),
      backdrop: this.theme.querySelector('div[data-backdrop="1"]'),
      closeButton: this.theme.querySelector('span[data-close-icon="1"]')
    }
  }
}

const wishlistDrawer = new WishlistDrawer()
